var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-text":"暗黑模式","inactive-text":"明亮模式","active-color":"#409eff","inactive-color":"#909399"},on:{"change":_vm.toggleTheme},model:{value:(_vm.isDark),callback:function ($$v) {_vm.isDark=$$v},expression:"isDark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }